import Heading, { HeadingProps } from './Heading';

export type H4Props = Omit<HeadingProps, 'as' | 'level'>;

/**
 * The smallest heading: an `<h4>` at visual level 4.
 *
 * ## When to use
 *
 * - The lowest heading level, nested under an `H3`.
 *
 * ## When to choose another component
 *
 * - **Higher-level headings** — use `H1`, `H2` or `H3`.
 * - **Emphasised or supporting text that is not a heading** — use `Text`.
 * - **Tag and visual level must differ** — use `Heading`, e.g.
 *   `<Heading as="h4" level={3}>`.
 *
 * ## Composition rules
 *
 * Fixed to `as="h4" level={4}`. It exposes no `as`, `level`, `className` or
 * `style`, so its typography and semantics cannot be overridden.
 */
const H4 = (props: H4Props) => <Heading as="h4" level={4} {...props} />;

export default H4;
